var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "calculator" }, [
    _c("h2", { staticClass: "calc-title" }, [
      _vm._v("Hae oma Ostosrahasi tästä")
    ]),
    _vm._v(" "),
    _c("div", [_vm._v("Valitse luottosumma ja takaisinmaksuaika")]),
    _vm._v(" "),
    _c("div", { staticClass: "loan calc-slider" }, [
      _c(
        "span",
        {
          attrs: { id: "loan-input" },
          on: {
            click: function($event) {
              _vm.showInput("loan")
            }
          }
        },
        [
          _c("input", {
            staticClass: "is-hidden",
            attrs: { id: "loan-text-input", name: "loan", type: "number" },
            on: { keydown: _vm.isNumber, keyup: _vm.handleTextInput }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "value", attrs: { id: "loan-value" } }, [
            _vm._v(_vm._s(_vm.loan.value))
          ]),
          _vm._v(" €")
        ]
      ),
      _vm._v(" "),
      _c("button", {
        staticClass: "step-button button-minus",
        class: { active: _vm.pressInterval },
        staticStyle: {
          "background-image":
            "url('/app/themes/opr-ostosraha/resources/assets/images/ic-minus.svg')"
        },
        attrs: {
          "aria-label": "Vähennä summaa",
          name: "decrease-amount",
          id: "loan-minus",
          type: "button"
        },
        on: {
          mousedown: _vm.subtractLoan,
          mouseleave: _vm.stop,
          mouseup: _vm.stop,
          touchstart: _vm.subtractLoan,
          touchend: _vm.stop,
          touchcancel: _vm.stop
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.loan.value,
            expression: "loan.value"
          }
        ],
        attrs: {
          "aria-label": "Valitse lainasumma",
          id: "loan-slider",
          type: "range",
          min: _vm.loan.min,
          max: _vm.loan.max,
          step: _vm.loan.interval
        },
        domProps: { value: _vm.loan.value },
        on: {
          input: _vm.handleInput,
          change: _vm.handleInput,
          mousedown: _vm.disableButtons,
          mouseleave: _vm.enableButtons,
          mouseup: _vm.enableButtons,
          touchstart: _vm.disableButtons,
          touchend: _vm.enableButtons,
          touchcancel: _vm.enableButtons,
          __r: function($event) {
            _vm.$set(_vm.loan, "value", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "step-button button-plus",
        class: { active: _vm.pressInterval },
        staticStyle: {
          "background-image":
            "url('/app/themes/opr-ostosraha/resources/assets/images/ic-plus.svg')"
        },
        attrs: {
          "aria-label": "Nosta summaa",
          name: "increase-amount",
          id: "loan-plus",
          type: "button"
        },
        on: {
          mousedown: _vm.addLoan,
          mouseleave: _vm.stop,
          mouseup: _vm.stop,
          touchstart: _vm.addLoan,
          touchend: _vm.stop,
          touchcancel: _vm.stop
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "time calc-slider" }, [
      _c(
        "span",
        {
          attrs: { id: "time-input" },
          on: {
            click: function($event) {
              _vm.showInput("time")
            }
          }
        },
        [
          _c("input", {
            staticClass: "is-hidden",
            attrs: { id: "time-text-input", name: "time", type: "number" },
            on: { keydown: _vm.isNumber, keyup: _vm.handleTextInput }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "value", attrs: { id: "time-value" } }, [
            _vm._v(_vm._s(_vm.paymentTime.value))
          ]),
          _vm._v(" v")
        ]
      ),
      _vm._v(" "),
      _c("button", {
        staticClass: "step-button button-minus",
        class: { active: _vm.pressInterval },
        staticStyle: {
          "background-image":
            "url('/app/themes/opr-ostosraha/resources/assets/images/ic-minus.svg')"
        },
        attrs: {
          "aria-label": "Vähennä aikaa",
          name: "decrease-time",
          id: "time-minus",
          type: "button"
        },
        on: {
          mousedown: _vm.subtractPaymentTime,
          mouseleave: _vm.stop,
          mouseup: _vm.stop,
          touchstart: _vm.subtractPaymentTime,
          touchend: _vm.stop,
          touchcancel: _vm.stop
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.paymentTime.value,
            expression: "paymentTime.value"
          }
        ],
        attrs: {
          "aria-label": "Valitse lainaika",
          id: "time-slider",
          type: "range",
          min: _vm.paymentTime.min,
          max: _vm.paymentTimeMax,
          step: _vm.paymentTime.interval
        },
        domProps: { value: _vm.paymentTime.value },
        on: {
          input: _vm.handleInput,
          change: _vm.handleInput,
          mousedown: _vm.disableButtons,
          mouseleave: _vm.enableButtons,
          mouseup: _vm.enableButtons,
          touchstart: _vm.disableButtons,
          touchend: _vm.enableButtons,
          touchcancel: _vm.enableButtons,
          __r: function($event) {
            _vm.$set(_vm.paymentTime, "value", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "step-button button-plus",
        class: { active: _vm.pressInterval },
        staticStyle: {
          "background-image":
            "url('/app/themes/opr-ostosraha/resources/assets/images/ic-plus.svg')"
        },
        attrs: {
          "aria-label": "Nosta aikaa",
          name: "increase-time",
          id: "time-plus",
          type: "button"
        },
        on: {
          mousedown: _vm.addPaymentTime,
          mouseleave: _vm.stop,
          mouseup: _vm.stop,
          touchstart: _vm.addPaymentTime,
          touchend: _vm.stop,
          touchcancel: _vm.stop
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "loan-info loan-info-1" }, [
      _c(
        "a",
        {
          staticClass: "button arrow",
          attrs: {
            id: "calculator-button",
            target: "_blank",
            href:
              "https://lainanhaku.ostosraha.fi/?lainabox=" +
              _vm.loan.value +
              "&aikabox=" +
              _vm.paymentTime.value * 100
          }
        },
        [
          _c("i", { staticClass: "far fa-arrow-alt-circle-right" }),
          _vm._v(" Hae kulutusluottoa tästä")
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "monthly has-text-weight-bold" }, [
      _c("span", { staticClass: "key" }, [_vm._v("Kuukausierä ")]),
      _c("span", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.monthlyPayment) + " €")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total has-text-weight-bold" }, [
      _c("span", { staticClass: "key" }, [_vm._v("Kokonaissumma ")]),
      _c("span", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.totalPayment) + " €")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "loan-info loan-info-2" }, [
      _vm._v(
        "Takaisinmaksettava kokonaissumma sisältää lainapääoman sekä kaikki korot ja kulut."
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "calc-title" }, [
      _c("i", { staticClass: "far fa-question-circle" }),
      _vm._v(" Esimerkkilaina")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loan-info loan-info-3" }, [
      _c("p", [
        _vm._v(
          "2000 € lainassa 3 vuoden laina-ajalla, todellinen vuosikorko on 28,9 %, huomioiden kaikki lainakustannukset. Lainan kuukausierä on 80,23 €, kuukausieriä 36 kpl ja takaisinmaksettava kokonaissumma 2888,11 € (sis. lainanhoitopalkkion 6 €/kk). Lainan nimelliskorko on 19,9 %."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/www/svea-ostosraha-fi/web/app/themes/opr-ostosraha/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/var/www/svea-ostosraha-fi/web/app/themes/opr-ostosraha/node_modules/vue-loader/lib?{}!./scripts/components/Calculator.vue?vue&type=template&id=04ce33c0&
// module id = 306
// module chunks = 0